module.exports = __webpack_public_path__ + "src/assets/img/twitter.5a5fce65.svg";